import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {datePicker_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/datePicker_template';


declare var ko: any;

declare var Dropzone: any;

export class websiteUserEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return /* html */ `
            <div class="form-header">
                <h3 class="form-title icon i-user-add">Edit Website User</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">

                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list margin">
                            <dt class=""><span>Full Name</span></dt>
                            <dd class=""><span data-bind="text: fullName()||''"></span></dd>
                            <dt class=""><span>Email Address</span></dt>
                            <dd class=""><span data-bind="text: email()||''"></span></dd>
                            <dt class=""><span>Is an Emaki User</span></dt>
                            <dd class=""><span data-bind="text: isEmakiUser()||'Not Selected'"></span></dd>
                            <dt class=""><span>Date Created</span></dt>
                            <dd class=""><span data-bind="text: dateCreated()||''"></span></dd>
                        </dl>
                    </div>
                </div>

                <div class="form-body">

                </div>

            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Brands</strong>

                    <div class="form-group">

                        <ul class="user-website-list" data-bind="foreach: accessPointUsers">
                            <li class="user-website-item">
                                <strong class="form-sub-title parent" data-bind="text: accessPoint.name, css: accessPoint.brands[0].iconImage"></strong>
                                <div class="form-group">
                                    <div class="form-check-inline">
                                        <input type="checkbox" data-bind="checked: isActive, attr:{id: 'is-active-' + accessPoint.id}">
                                        <label class="form-label icon i-check" data-bind="attr:{for: 'is-active-' + accessPoint.id}" ><span>Is Active</span></label>
                                    </div>
                                    <div class="form-check-inline">
                                        <input type="checkbox" data-bind="checked: isRegistered, attr:{id: 'is-registered-' + accessPoint.id}" disabled>
                                        <label class="form-label icon i-check" data-bind="attr:{for: 'is-registered-' + accessPoint.id}" ><span>Is Registered</span></label>
                                    </div>
                                    <div class="form-check-inline">
                                        <input type="checkbox" data-bind="checked: isPremiumFree, attr:{id: 'is-premium-free' + accessPoint.id, disabled: !$parent.permissions()['website_user_admin_premium_free'].read }">
                                        <label class="form-label icon i-check" data-bind="attr:{for: 'is-premium-free' + accessPoint.id}" ><span>Is Premium (Free)</span></label>
                                    </div>
                                    <div class="form-check-inline">
                                        <input type="checkbox" data-bind="checked: isPremium, attr:{id: 'is-premium-' + accessPoint.id}" disabled>
                                        <label class="form-label icon i-check" data-bind="attr:{for: 'is-premium-' + accessPoint.id}" ><span>Is Premium (Paid)</span></label>
                                    </div>
                                    <div data-bind="visible: isPremiumFree">
                                        <div class="form-check-inline"  style="margin-top: 1rem;">
                                            <label>Free Premium End Date</label>
                                            <div class="" data-bind="template: { name: 'datePicker-template', value: singleDatePicker },  attr:{disabled: !$parent.permissions()['website_user_admin_premium_free'].read}"></div>
                                        </div>
                                    </div>
                                     
                                </div>
                                <strong class="form-sub-title">User Profile</strong>
                                <div class="form-group w-user-profile">

                                    <div class="w-user-profile-header">
                                        <div class="w-user-profile-info">
                                            <div class="user-profile-info">
                                                <!-- ko if: $data.idProfile -->
                                                    <a class="right-click" data-bind="attr: { href: profilePageLink}" target="_blank"><span class="btn icon only-icon inline-small i-link"></span></a>
                                                <!-- /ko -->
                                                <!-- ko if: $data.pendingDisplayName -->
                                                    <div class="d-flex" style="flex-direction: column;">
                                                        <span class="display-name" id="display-name" data-bind="text: $data.pendingDisplayName"></span>
                                                        <div class="user-id" id="display-name" data-bind="text: $data.idProfile ? $data.idProfile : 'Public ID Not Yet Assigned'"></div>
                                                    </div>
                                                <!-- /ko -->
                                                <!-- ko ifnot: $data.pendingDisplayName -->
                                                    <div class="d-flex" style="flex-direction: column;">
                                                        <span class="display-name" id="display-name" data-bind="text: $data.displayName ? $data.displayName : 'Display Name Not Set'"></span>
                                                        <div class="user-id" id="display-name" data-bind="text: $data.idProfile ? $data.idProfile : 'Public ID Not Yet Assigned'"></div>
                                                    </div>
                                                <!-- /ko -->
                                                <div class="user-interaction">
                                                    <div class="user-moderation">
                                                    <!-- ko if: $parent.getDisplayNameImageEditPermission()  -->
                                                        <!-- ko if: $data.displayName || $data.pendingDisplayName-->
                                                            <a title="Reject"><span class="btn icon only-icon inline-small i-rejected-moderation" data-bind="event: { click: $parent.confirmRejectDisplayName }"></span></a>
                                                        <!-- /ko -->
                                                        <!-- ko if: $data.pendingDisplayName -->
                                                            <a title="Approve"><span class="btn icon only-icon inline-small i-approved-moderation" data-bind="event: { click: $parent.approveDisplayName }"></span></a>
                                                        <!-- /ko -->
                                                    <!-- /ko -->
                                                    </div>
                                                </div>
                                                <div style="flex: 1;text-align: end;">
                                                    <label><span>Date Registered</span></label>
                                                    <div id="display-name" data-bind="text: $data.dateCreatedFormat ? $data.dateCreatedFormat : ''"></div>
                                                </div>
                                            </div>

                                            <!-- ko if: $data.displayName || $data.pendingDisplayName -->
                                                <div class="display-name-status" id="display-name-status" data-bind="text: $data.pendingDisplayNameStatus, css : $data.pendingDisplayNameStatus.toLowerCase()"></div>
                                            <!-- /ko -->
                                        </div>
                                        <div class="user-profile-data">
                                            <div>
                                                <label><span>Posts</span></label>
                                                <div id="display-name" data-bind="text: $data.commentCount ? $data.commentCount : '0'"></div>
                                            </div>
                                            <div>
                                                <label><span>Ratings</span></label>
                                                <div id="display-name" data-bind="text: $data.followTagsCount ? $data.followTagsCount : '0'"></div>
                                            </div>
                                            <div>
                                                <label><span>Reviews</span></label>
                                                <div id="display-name" data-bind="text: $data.reviewCount ? $data.reviewCount : '0'"></div>
                                            </div>
                                            <div>
                                                <label><span>Threads</span></label>
                                                <div id="display-name" data-bind="text: $data.threadCount ? $data.threadCount : '0'"></div>
                                            </div>
                                            <div>
                                                <label><span>Followers</span></label>
                                                <div id="display-name" data-bind="text: $data.followerCount ? $data.followerCount : '0'"></div>
                                            </div>
                                            <div>
                                                <label><span>Items in Lists</span></label>
                                                <div id="display-name" data-bind="text: $data.itemsInListsCount ? $data.itemsInListsCount : '0'"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="w-user-custom-image" style="flex-direction: row;">
                                        <div class="form-group">
                                            <label class="form-label" for="display-image">Default Display Image</label>
                                            <div class="w-image">
                                                <div class="display-image-status"></div>
                                                <img class="display-image" data-bind="attr: {src: $data.profilePicture, alt: $data.profilePicture ? $data.profilePicture : 'Display Image Not Set'}">
                                            </div>
                                        </div>
                                        <div class="w-user-custom-image">
                                        <label class="form-label" for="custom-profile-picture">Custom Profile Picture</label>
                                        <!-- ko if: $data.customProfilePicture -->
                                            <div class="user-interaction">
                                                <div class="user-moderation">
                                                <!-- ko if: $parent.getDisplayNameImageEditPermission() -->
                                                    <a title="Reject"><span class="btn icon only-icon i-rejected-moderation" data-bind="event: { click: $parent.confirmRejectDisplayImage }"></span></a>
                                                    <!-- ko ifnot: $data.isCustomProfilePictureValidated -->
                                                        <a title="Approve"><span class="btn icon only-icon i-approved-moderation" data-bind="event: { click: $parent.approveDisplayImage }"></span></a>
                                                    <!-- /ko -->
                                                <!-- /ko -->
                                                </div>
                                            </div>
                                            <div class="w-image custom-image">
                                                <div class="display-image-status submitted above-content" data-bind="text: $data.customDisplayImageStatus, css : $data.customDisplayImageStatusClass"></div>
                                                <img class="display-image" style="max-width: 150px; max-height: 150px;" data-bind="attr: {src: $data.customProfilePicture, alt: $data.customProfilePicture}">
                                            </div>
                                        <!-- /ko -->
                                        <!-- ko ifnot: $data.customProfilePicture -->
                                            <div class="w-image">
                                                <div class="cover-image-status"></div>
                                                <span>Custom Profile Picture Not Set</span>
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                    </div>

                                    <div class="w-user-custom-image">
                                        <label class="form-label" for="cover-image">Cover Image</label>
                                        <!-- ko if: $data.coverImage -->
                                            <div class="user-interaction">
                                                <div class="user-moderation">
                                                <!-- ko if: $parent.getDisplayNameImageEditPermission() -->
                                                    <a title="Reject"><span class="btn icon only-icon i-rejected-moderation" data-bind="event: { click: $parent.confirmRejectCoverImage }"></span></a>
                                                    <!-- ko ifnot: $data.isCoverImageValidated -->
                                                        <a title="Approve"><span class="btn icon only-icon i-approved-moderation" data-bind="event: { click: $parent.approveCoverImage }"></span></a>
                                                    <!-- /ko -->
                                                <!-- /ko -->
                                                </div>
                                            </div>
                                            <div class="w-image custom-image">
                                                <div class="cover-image-status submitted above-content" data-bind="text: $data.coverImageStatus, css : $data.coverImageStatusClass"></div>
                                                <img class="cover-image" style="max-width: 150px; max-height: 150px;" data-bind="attr: {src: $data.coverImage, alt: $data.coverImage}">
                                            </div>
                                        <!-- /ko -->
                                        <!-- ko ifnot: $data.coverImage -->
                                            <div class="w-image">
                                                <div class="cover-image-status"></div>
                                                <span>Cover Image Not Set</span>
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                </div>

                                <strong class="form-sub-title" data-bind="visible: accessPointMailingLists && accessPointMailingLists.length > 0">Mailing Lists</strong>

                                <div class="form-group mailing-list" data-bind="visible: accessPointMailingLists && accessPointMailingLists.length > 0">
                                    <div data-bind="foreach: accessPointMailingLists">
                                        <div class="form-check-inline">
                                            <input data-bind="value: id, checked: isUserActive, attr:{id: 'mailing-list-' + id}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="click: $parents[1].onClickMailingList.bind($data, $parent), text: name, attr:{for: 'mailing-list-' + id}, css: { 'is-disable' : !isPrimary && !$parent.isPrimaryMailingListSelected } "></label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" data-bind="if: subscriptions && subscriptions.length > 0">
                                    <strong class="form-sub-title">Premium Subscription</strong>
                                    <div class="form-group">
                                        <dl class="double-list margin">
                                            <dt class=""><span>Subscription ID</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].idSubscription||''"></span></dd>
                                            <dt class=""><span>Name</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].name||''"></span></dd>
                                            <dt class=""><span>Status</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].status ||''"></span></dd>
                                            <dt class=""><span>Price</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].price + ' ' + subscriptions[0].currency + ' / ' + subscriptions[0].frequencyUnit"></span></dd>
                                            <dt class=""><span>Start Date</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].dateCreated ? new Date(subscriptions[0].dateCreated.date).toISOString().substring(0, 19).replace('T', ' ') : ''"></span></dd>
                                            <dt class=""><span>Start Billing Date</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].startBillingDate ? subscriptions[0].startBillingDate.date.substring(0, 19) : ''"></span></dd>
                                            <dt class=""><span>End Date</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].endDate ? subscriptions[0].endDate.date.substring(0, 19) : ''"></span></dd>
                                            <dt class=""><span>Next Payment</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].nextBillingDate ? subscriptions[0].nextBillingDate.date.substring(0, 19) : ''"></span></dd>
                                            <dt class=""><span>Last Payment</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].lastBillingDate ? subscriptions[0].lastBillingDate.date.substring(0, 19) : ''"></span></dd>
                                            <dt class=""><span>Cycles Completed</span></dt>
                                            <dd class=""><span data-bind="text: subscriptions[0].cyclesCompleted.toString()"></span></dd>
                                        </dl>
                                    </div>
                                    <div class="form-footer" data-bind="visible: subscriptions[0].endDate && subscriptions[0].endDate.date > new Date().toISOString()" style="flex-direction: column">
                                        <div class="form-group-row" style="margin-bottom: 2rem;">
                                            <div style="display: flex; flex: 1; gap: .5rem; margin: 0; align-items: center; justify-content: flex-start">
                                                <label class="form-label"><span>Cancel Subscription</span></label>
                                                <div class="w-tooltips-adv pos-top short" data-bind="template: { name: 'infoButton-template', data: $data.cancelSubscriptionTooltip.getTemplateViewModel() }"></div>
                                            </div>
                                            <button data-bind="enable: $parent.permissions()['website_user_admin_premium'].read && subscriptions[0].status == 'ACTIVE',  event: { click: $parent.onClickShowPopup.bind($data, 'cancel')}" class="btn icon i-check" type="button">Cancel Subscription</button>
                                        </div>
                                        <div class="form-group-row">
                                            <div style="display: flex; flex: 1; gap: .5rem; margin: 0; align-items: center; justify-content: flex-start">
                                                <label class="form-label">
                                                    <span>Revoke Subscription</span>
                                                </label>
                                                <div class="w-tooltips-adv pos-top short" data-bind="template: { name: 'infoButton-template', data: $data.revokeSubscriptionTooltip.getTemplateViewModel() }"></div>
                                            </div>
                                            <button data-bind="enable: $parent.permissions()['website_user_admin_premium'].read && (subscriptions[0].status == 'SUSPENDED' || (subscriptions[0].status == 'CANCELLED' && subscriptions[0].endDate && subscriptions[0].endDate.date > new Date().toISOString())), event: { click: $parent.onClickShowPopup.bind($data, 'revoke') }" class="btn highlight icon i-check" type="button">Revoke Subscription</button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
             <div class="form-footer">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>

            <div id="confirm-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">CONFIRM ACTION</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopup }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <span data-bind="text: 'Are you sure you want to ' + subscriptionAction() + ' the subscription?'" style="font-size: 14px;"></span>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopup }" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickUpdateSubscription }" class="btn border only-icon icon">Ok</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="confirm-moderation-dialog" class="w-lightbox light-theme" data-bind="class: userModerationDialogVisibility() ? 'is-visible' : ''">
                <div class="lightbox-content confirm-user-moderation">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: userModerationTitle"></h3>
                            <button type="button"  data-bind="event: { click: onClickHideUserModerationDialogVisibility }" class="close-button icon i-close-2"></button>
                        </div>
                        <div id="confirm-user-moderation-body" class="form-body">
                            <div class="form-group user-delete">
                                <p class="form-text alert-error" data-bind="text: userModerationMessage"></p><img style="max-width: 100%; max-height: 500px;" data-bind="attr: { src: userModerationImage }">
                            </div>
                         </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideUserModerationDialogVisibility }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickRejectUserModerationDialogVisibility }" class="btn highlight">Reject</button>
                        </div>
                    </div>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        for (let i = 1; i <= 30; i++) {
            if (i === 2) continue; // skip number 2
          
            const id = `premium-free-end-date${i}`;
            (this as any)[id] = new datePicker_template(
              id,
              this.getTemplateViewModel(),
              this.caller
            );
          }

    }

    public buildDatePickerCalendar(accessPointUsers) {
        const suffixes = [];
        if(Array.isArray(accessPointUsers)){
            accessPointUsers.forEach(item => {
                suffixes.push(item.accessPoint.id);
            });
        }
        console.log();     

        suffixes.forEach((suffix) => {
            const picker = (this as any)[`premium-free-end-date${suffix}`];
            if (picker && typeof picker.buildCalendarWithoutTime === 'function') {
                picker.buildCalendarWithoutTime();
            }
        });
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , fullName: ko.observable("")
            , email: ko.observable("")
            , isEmakiUser: ko.observable("false")
            , dateCreated: ko.observable("")
            , isPrimaryMailingListSelected: ko.observable(false)
            , accessPointUsers: ko.observableArray([])
            //, isPremiumFree: ko.observable(null)
            , subscriptionToUpdate: ko.observable(null)
            , subscriptionAction: ko.observable('')
            , permissions: ko.observableArray(this.initPermissions(['website_user_admin_premium', 'website_user_admin_premium_free', 'website_user_display_name_image_edit'])) //TODO: add the new permission for the name and image moderation
            , userModerationDialogVisibility: ko.observable(false)
            , userModerationState: ko.observable('')
            , userModerationTitle: ko.observable('')
            , userModerationMessage: ko.observable('')
            , userModerationImage: ko.observable('')
            , idTargetAccessPointUser: ko.observable(null)
            , approveDisplayName: this.approveDisplayName.bind(this)
            , rejectDisplayName: this.rejectDisplayName.bind(this)
            , confirmRejectDisplayName: this.confirmRejectDisplayName.bind(this)
            , approveDisplayImage: this.approveDisplayImage.bind(this)
            , rejectDisplayImage: this.rejectDisplayImage.bind(this)
            , confirmRejectDisplayImage: this.confirmRejectDisplayImage.bind(this)
            , approveCoverImage: this.approveCoverImage.bind(this)
            , confirmRejectCoverImage: this.confirmRejectCoverImage.bind(this)
            , rejectCoverImage: this.rejectCoverImage.bind(this)
            , onClickHideUserModerationDialogVisibility: this.onClickHideUserModerationDialogVisibility.bind(this)
            , onClickRejectUserModerationDialogVisibility: this.onClickRejectUserModerationDialogVisibility.bind(this)
            , getDisplayNameImageEditPermission: this.getDisplayNameImageEditPermission.bind(this)
            , singleDatePicker: ko.observable(null)
            , onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();
            }
            ,onClickSave: function (data, event) {
                self.onClickSave()
            }
            ,onClickShowPopup: function (action, data, event) {
                self.onClickShowPopup(action, data);
            }
            ,onClickHidePopup: function (data, event) {
                self.onClickHidePopup()
            }
            ,onClickUpdateSubscription: function (data, event) {
                self.onClickUpdateSubscription()
            }
            ,onClickMailingList: function (parent, data, event) {
                self.onClickMailingList(parent, data, event)
            }
            ,removeImageOnDropZone: function (element) {
                self.removeImageOnDropZone(element)
            }
        }
    }

    protected getTemplateName(): string {
        return "websiteUserEdit_template";
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }

    public setFullName(fullName){
        this.getTemplateViewModel().fullName(fullName)
    }

    public setIsEmakiUser(isEmakiUser){
        this.getTemplateViewModel().isEmakiUser(isEmakiUser)
    }

    public setDateCreated(dateCreated){
        this.getTemplateViewModel().dateCreated(dateCreated)
    }

    public setEmail(email){
        this.getTemplateViewModel().email(email)
    }

    public setAccessPointUsers(accessPointUsers){

        this.getTemplateViewModel().accessPointUsers(accessPointUsers)
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }

    protected onClickShowPopup(action, data): any {

        this.getTemplateViewModel().subscriptionAction(action);
        this.getTemplateViewModel().subscriptionToUpdate(data.subscriptions ? data.subscriptions[0] : null);
        document.getElementById("confirm-dialog").classList.add("is-visible");
    }

    protected onClickHidePopup(): any {

        this.getTemplateViewModel().subscriptionAction('');
        this.getTemplateViewModel().subscriptionToUpdate(null);
        document.getElementById("confirm-dialog").classList.remove("is-visible");
    }

    protected onClickUpdateSubscription(): any {
        this.caller.updateSubscription();
    }

    protected onClickMailingList(parent, data, event): any {

        let element : any = document.getElementById(event.target.getAttribute('for'));

        element.checked = !element.checked;

        if(element.checked){
            data.isUserActive = true;
            if(data.isPrimary){
                parent.isPrimaryMailingListSelected = true;
            }
        }else{
            data.isUserActive = false;
            if(data.isPrimary){
                parent.isPrimaryMailingListSelected = false;
            }
        }


        //set all others to unchecked
        if(data.isPrimary){
            for(let list of parent.accessPointMailingLists){
                if(!list.isPrimary){
                    list.isUserActive = false;
                }
            }
        }

        let accessPointUsers = this.getTemplateViewModel().accessPointUsers();

        for(let user of accessPointUsers){
            if(user.id == parent.id){
                user = parent;
            }
        }

        this.getTemplateViewModel().accessPointUsers([]);
        this.getTemplateViewModel().accessPointUsers(accessPointUsers);

        return false;
    }

    public removeImageOnDropZone(element : HTMLInputElement): any {
        const { targetDropzone, accessPointIndex} = element.dataset;
        const myDropzone = Dropzone.forElement(`div#${targetDropzone}`);
        myDropzone.files.forEach(file => {
            //Param to know where to delete
            file.accessPointIndex = accessPointIndex
        });
        myDropzone.removeAllFiles(true);

    }

    public setPermissions(permission) {

        this.getTemplateViewModel().permissions(permission);
        //this.singleDatePicker.setIsPickerDisabled(true);
    }

    private approveDisplayName(accessPointUser) {
        this.caller.moderateDisplayName(accessPointUser.id, 'approve');
    }
    private confirmRejectDisplayName(accessPointUser) {
        this.setIDTargetAccessPointUser(accessPointUser.id)
        this.showUserModerationDialog("rejectDisplayName", "Reject Display Name", `Are you sure you want to reject '${accessPointUser.pendingDisplayName || accessPointUser.displayName}'? This action is irreversible.`);
    }
    private rejectDisplayName(idAccessPointUser) {
        this.caller.moderateDisplayName(idAccessPointUser, 'reject');
    }


    private approveDisplayImage(accessPointUser) {
        this.caller.moderateDisplayImage(accessPointUser.id, 'approve');
    }
    private confirmRejectDisplayImage(accessPointUser) {
        this.setIDTargetAccessPointUser(accessPointUser.id)
        this.showUserModerationDialog("rejectDisplayImage", "Reject Custom User Display Image", "Are you sure you want to reject the custom display image? This action is irreversible.", accessPointUser.customProfilePicture || accessPointUser.profilePicture);
    }
    private rejectDisplayImage(idAccessPointUser) {
        this.caller.moderateDisplayImage(idAccessPointUser, 'reject');
    }

    private onClickRejectUserModerationDialogVisibility() {
        const state = this.getUserModerationState();
        switch (state) {
            case "rejectDisplayName":
                this.rejectDisplayName(this.getIDTargetAccessPointUser());
                break;
            case "rejectDisplayImage":
                this.rejectDisplayImage(this.getIDTargetAccessPointUser());
                break;
            case "rejectCoverImage":
                this.rejectCoverImage(this.getIDTargetAccessPointUser());
                break;
        }

        this.setUserModerationDialogVisibility(false);
    }

    private approveCoverImage(accessPointUser) {
        this.caller.moderateCoverImage(accessPointUser.id, 'approve');
    }
    private confirmRejectCoverImage(accessPointUser) {
        this.setIDTargetAccessPointUser(accessPointUser.id)
        this.showUserModerationDialog("rejectCoverImage", "Reject User Cover Image", "Are you sure you want to reject the cover image? This action is irreversible.", accessPointUser.coverImage);
    }
    private rejectCoverImage(idAccessPointUser) {
        this.caller.moderateCoverImage(idAccessPointUser, 'reject');
    }

    private onClickHideUserModerationDialogVisibility() {
        this.setUserModerationDialogVisibility(false);
    }

    public setUserModerationDialogVisibility(visibility) {
        this.getTemplateViewModel().userModerationDialogVisibility(visibility);
    }

    public updateAccessPointUserDisplayName(accessPointUser) {
        let accessPointUsers = this.getTemplateViewModel().accessPointUsers();
        for (let index = 0; index < accessPointUsers.length; index++) {
            if (accessPointUsers[index].id == accessPointUser.id) {
                accessPointUsers[index].displayName = accessPointUser.displayName;
                accessPointUsers[index].pendingDisplayName = accessPointUser.pendingDisplayName;
                break;
            }
        }
        this.getTemplateViewModel().accessPointUsers([]);
        this.getTemplateViewModel().accessPointUsers(accessPointUsers);
    }

    public updateAccessPointUserDisplayImage(accessPointUser) {
        let accessPointUsers = this.getTemplateViewModel().accessPointUsers();
        for (let index = 0; index < accessPointUsers.length; index++) {
            if (accessPointUsers[index].id == accessPointUser.id) {
                accessPointUsers[index].customProfilePicture = accessPointUser.customProfilePicture;
                accessPointUsers[index].isCustomProfilePictureValidated = accessPointUser.isCustomProfilePictureValidated;
                break;
            }
        }
        this.getTemplateViewModel().accessPointUsers([]);
        this.getTemplateViewModel().accessPointUsers(accessPointUsers);
    }


    public updateAccessPointUserCoverImage(accessPointUser) {
        let accessPointUsers = this.getTemplateViewModel().accessPointUsers();
        for (let index = 0; index < accessPointUsers.length; index++) {
            if (accessPointUsers[index].id == accessPointUser.id) {
                accessPointUsers[index].coverImage = accessPointUser.coverImage;
                accessPointUsers[index].isCoverImageValidated = accessPointUser.isCoverImageValidated;
                break;
            }
        }
        this.getTemplateViewModel().accessPointUsers([]);
        this.getTemplateViewModel().accessPointUsers(accessPointUsers);
    }

    public showUserModerationDialog(state="", title="", message="", image="") {
        this.setUserModerationDialogVisibility(true);
        this.getTemplateViewModel().userModerationState(state);
        this.getTemplateViewModel().userModerationTitle(title);
        this.getTemplateViewModel().userModerationMessage(message);
        this.getTemplateViewModel().userModerationImage(image);
    }

    public getUserModerationState() {
        return this.getTemplateViewModel().userModerationState();
    }

    public setIDTargetAccessPointUser(idTargetAccessPointUser) {
        return this.getTemplateViewModel().idTargetAccessPointUser(idTargetAccessPointUser);
    }

    public getIDTargetAccessPointUser() {
        return this.getTemplateViewModel().idTargetAccessPointUser();
    }

    public getDisplayNameImageEditPermission() {
        return this.getTemplateViewModel().permissions() &&
               this.getTemplateViewModel().permissions()['website_user_display_name_image_edit'] && (
                this.getTemplateViewModel().permissions()['website_user_display_name_image_edit'].write ||
                this.getTemplateViewModel().permissions()['website_user_display_name_image_edit'].update
               );
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {
            date = new Date();
        }

        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);

        return date;
    }

    private getFormattedEasternTimeZoneDateTime(): any {

        let date = this.createEasternTimeZoneDateTime();

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        console.log(year + '/' + this.padInteger(month,2) + '/' + this.padInteger(day,2) + ' ' + this.padInteger(hour,2) + ':' + this.padInteger(minutes,2));

        return year + '/' + this.padInteger(month,2) + '/' + this.padInteger(day,2) + ' ' + this.padInteger(hour,2) + ':' + this.padInteger(minutes,2);
    }

    private padInteger(number: number, size: number)
    {
        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public isDstObserved (date?: Date) {
        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < stdTimezoneOffset;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/websiteUserEdit_template.ts